import Vue from 'vue';
var infiniteScroll =  require('vue-infinite-scroll');

Vue.use(infiniteScroll);

export default Vue;
